import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LocalStorageKeyOptions, LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptorService {

  constructor(private authenticationService: AuthenticationService,
    private local: LocalStorageService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return next.handle(request).pipe(catchError(err => {
          if ([401].indexOf(err.status) !== -1) {      
            this.authenticationService.logout();
            location.reload(true);     
              /*if(!this.authenticationService.RefreshToken()){
                this.authenticationService.logout();
                location.reload(true);
              }*/              
              return;              
          }
          if ([403].indexOf(err.status) !== -1) {
            // redirect to unauthorised.
            this.authenticationService.unAuthorised();
            return;
        }
          const error = err.error?.message || err.statusText;
          return throwError(error);
      }));
  }
  
}
